import { Component, ElementRef, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WrapperComponent } from '../../wrapper/wrapper.component';
import { FilterToolComponent } from '@/app/components/global/filter-tool/filter-tool.component';
import { MatDialog } from '@angular/material/dialog';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatMenuModule } from '@angular/material/menu';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { AddRfiComponent } from './add-rfi/add-rfi.component';
@Component({
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    WrapperComponent,
    FilterToolComponent,
    MatMenuModule,
    AddRfiComponent,
  ],
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.css'],
})
export class ContractorComponent implements OnInit {
  currentDialog = 'RFI';
  activeRowIndex: number | null = null;
  savedRfiData: any = [];
  tableData!: any;
  projectId: any;
  projectIdNew: any;
  projectName: string;
  projectIdentifier: string;
  private subscription: Subscription = new Subscription();
  isDialogOpen: boolean = false;
  org_info: any = localStorage.getItem('org_info')
    ? JSON.parse(localStorage.getItem('org_info') as string)
    : null;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private getProjectIdService: GetProjectIdService,
    private elementRef: ElementRef,
    private tenderingService: TenderingService,
    private route: ActivatedRoute,
    private rfiService: RfiService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.projectId = this.getProjectIdService.getProjectId();
    this.getRfiListing();
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.getProjectIdService.getProjectId();
      }
      this.getRfiListing();
    });
  }

  getRfiListing(): any {
    return this.rfiService.getRfiList(this.org_info?.id).subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          this.tableData = data?.data;
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  openView(rfiId: any) {
    localStorage.setItem('rfi_id', rfiId);
    this.router.navigate(['/contractor/rfi-view', this.projectId, rfiId], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  handleCreateRfi() {
    this.isDialogOpen = !this.isDialogOpen;
  }

  handleDialog() {
    this.isDialogOpen = !this.isDialogOpen;
    this.getRfiListing();
  }

  openDialog() {
    this.isDialogOpen = !this.isDialogOpen;
  }
  loadRfiData() {
    this.getRfiListing();
  }
}
